'use strict';

export default function SearchFilterBlockWithTooltip({
    title,
    tooltip_title,
    containerClass,
    onClick
})
{
    const containerRef = React.useRef();

    React.useEffect(() => {

        if (containerRef.current) {

            $(function () {

                const $link = $(containerRef.current);
                if (!$link.length) return;

                const $tooltip = $('<div class="wtp-tooltip"></div>').appendTo('body');

                $link.on('mouseenter', function () {
                    const $this = $(this);

                    $tooltip.text(tooltip_title);

                    const offset = $this.offset();
                    const tooltipHeight = $tooltip.outerHeight();

                    $tooltip.css({
                        left: offset.left,
                        top: offset.top - tooltipHeight - 10,
                        opacity: 1,
                        visibility: 'visible'
                    });
                });

                $link.on('mouseleave', function () {
                    $tooltip.css({
                        opacity: 0,
                        visibility: 'hidden'
                    });
                });

                $(window).on("scroll", function(){
                    $tooltip.css({
                        opacity: 0,
                        visibility: 'hidden'
                    });
                })

            });
        }
    }, [])

    const handleClick = () => {
        onClick && onClick()
    }

    const className = containerClass || "watch-the-price el-sidebar__single";

    return <a ref={containerRef} role='button' className={className} onClick={handleClick}>
        {title} <i className="icon-favorite"></i>
    </a>
}